<template>
  <li class="py-4 flex items-center space-x-3">
    <img v-if="hasPreview || isImage" class="h-10 w-10 rounded-full" :src="previewUrl" alt="" />
    <div class="flex-1 w-0">
      <p class="text-sm font-medium text-gray-900 truncate">
        {{ temporaryUpload.fileName }}
      </p>
      <p class="text-sm text-gray-500">{{ $t('global.size') }}: {{ formattedFileSize }}</p>
    </div>
    <div>
      <button
        type="button"
        :disabled="loading"
        class="capitalize inline-flex items-center shadow-sm px-2.5 py-0.5 border border-red-300 text-sm leading-5 font-medium rounded-full text-red-700 bg-white hover:bg-red-50 disabled:border-gray-300 disabled:text-gray-700 disabled:bg-gray-100 disabled:pointer-default"
        @click="remove"
      >
        {{ $t('global.remove') }}
      </button>
    </div>
  </li>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    temporaryUpload: {
      type: Object,
      required: true,
    },
    onRemove: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isImage() {
      return this.temporaryUpload.mimeType.indexOf('image/') === 0;
    },
    hasPreview() {
      return typeof this.temporaryUpload.previewUrl === 'string';
    },
    previewUrl() {
      if (this.hasPreview) {
        return this.temporaryUpload.previewUrl;
      }

      if (this.isImage) {
        return this.temporaryUpload.url;
      }

      return null;
    },
    formattedFileSize() {
      return Numbro(this.temporaryUpload.size || 0).format({
        output: 'byte',
        base: 'binary',
        mantissa: 1,
        spaceSeparated: true,
      });
    },
  },
  methods: {
    async remove() {
      this.loading = true;

      await this.onRemove(this.temporaryUpload).catch(() => {
        this.loading = false;
      });

      this.loading = false;
    },
  },
};
</script>
